import React, { FunctionComponent, useState } from 'react';
import { fmtPrice } from '@upstart/harmony/lib/formatter';
import { DeskingOffer } from '@upstart/harmony/lib/legos/deskingTypes';
import { FinanceType } from '@upstart/harmony/lib/constants';
import { MdCalculate } from 'react-icons/md';
import { DealerWithFlags } from '@upstart/harmony/lib/legos/dealerTypes';
import PaymentRollbackModal from './PaymentRollbackModal';
import '../OfferCardHeader.scss';

interface Props {
  deskingOffer: DeskingOffer;
  monthlyPayment?: number[];
  showBiweeklyPayments?: boolean;
  financeType?: FinanceType.PURCHASE | FinanceType.LEASE;
  months?: number;
  onPaymentRollbackChange: (
    field: string,
    type?: 'price' | 'percentage' | 'number' | 'checkbox',
    maxValue?: number | null,
  ) => (value: number) => void;
  readOnlyMode: boolean;
  dealer: DealerWithFlags;
}

const MonthlyPaymentRow: FunctionComponent<Props> = ({
  monthlyPayment,
  showBiweeklyPayments,
  financeType,
  months,
  deskingOffer,
  onPaymentRollbackChange,
  readOnlyMode,
  dealer,
}) => {
  const [openModel, setOpenModel] = useState<boolean>(false);
  const label = showBiweeklyPayments ? 'biweekly' : 'month';
  let displayValue;
  if (monthlyPayment) {
    displayValue = monthlyPayment.map(payment => fmtPrice(payment)).join('-');
  } else {
    displayValue = fmtPrice(0);
  }
  return (
    <div className="payment-row">
      {displayValue}
      <span className="payment-frequency">/{label}</span>
      {!readOnlyMode && financeType === FinanceType.PURCHASE && (
        <>
          <button
            type="button"
            className="edit-button"
            onClick={() => setOpenModel(true)}
          >
            <MdCalculate className="icon" />
          </button>
          <PaymentRollbackModal
            monthlyPayment={monthlyPayment}
            months={months}
            deskingOffer={deskingOffer}
            onPaymentRollbackChange={onPaymentRollbackChange}
            isOpen={openModel}
            onClose={() => setOpenModel(false)}
            dealer={dealer}
          />
        </>
      )}
    </div>
  );
};

export default MonthlyPaymentRow;
